<template>
  <div class="banner-preview-modal t-banner-preview-modal">
    <div style="overflow-x: auto;">
      <banner-preview
        :image-name="banner.imageName"
        :title="bannerContent.title"
        :text="bannerContent.text"
        v-bind="{
          ...(bannerContent.primaryButton != null
            ? {
              primaryButtonText: bannerContent.primaryButton.text,
              primaryButtonLink: bannerContent.primaryButton.link,
              primaryButtonLinkInternal: bannerContent.primaryButton.isInternalLink
            }
            : undefined
          ),
          ...(bannerContent.secondaryButton != null
            ? {
              secondaryButtonText: bannerContent.secondaryButton.text,
              secondaryButtonLink: bannerContent.secondaryButton.link,
              secondaryButtonLinkInternal: bannerContent.secondaryButton.isInternalLink
            }
            : undefined
          )
        }"
      />
    </div>

    <div class="banner-preview-modal__actions">
      <v-btn
        color="primary"
        :to="createBannerEditRoute(banner.id)"
      >edit banner</v-btn>

      <v-btn
        color="white"
        outline
        @click="onCloseButtonClick"
      >close preview</v-btn>
    </div>
  </div>
</template>

<script>
  // Utils
  import { createBannerEditRoute } from '@/utils/routing/Banners'

  // Mixins
  import modal from '@/mixins/modal'

  // Components
  import BannerPreview from '@/components/banners/BannerPreview'

  export default {
    name: 'BannerPreviewModal',
    components: {
      BannerPreview
    },
    mixins: [modal],
    computed: {
      banner () {
        return this.modalData.banner
      },
      bannerContent () {
        return this.banner.en
      }
    },
    methods: {
      createBannerEditRoute,
      onCloseButtonClick () {
        this.closeModal()
      }
    }
  }
</script>

<style lang="scss">
  .banner-preview-modal {
    &__actions {
      display: flex;
      justify-content: center;
      padding-top: 26px;
    }
  }

</style>
